import React from 'react';

export const Icon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} />
);

export const LayoutDashboard = (props) => (
    <Icon {...props}><title>Layout Dashboard</title><rect width="7" height="9" x="3" y="3" rx="1" /><rect width="7" height="5" x="14" y="3" rx="1" /><rect width="7" height="9" x="14" y="12" rx="1" /><rect width="7" height="5" x="3" y="16" rx="1" /></Icon>
);

export const HandCoins = (props) => (
    <Icon {...props}><title>Hand Coins</title><path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17" /><path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.7-2.9l-4.2 4.2c-.3.3-.8.5-1.2.5h-2" /><path d="m10.1 12.1 4.2-4.2c.8-.8 2.1-.8 2.8 0L22 12.8" /><circle cx="12" cy="12" r="10" /></Icon>
);

export const Users = (props) => (
    <Icon {...props}><title>Users</title><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></Icon>
);

export const Settings = (props) => (
    <Icon {...props}><title>Settings</title><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 0 2l-.15.08a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l-.22-.38a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1 0-2l.15-.08a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" /></Icon>
);

export const LifeBuoy = (props) => (
    <Icon {...props}><title>Life Buoy</title><circle cx="12" cy="12" r="10" /><path d="m4.93 4.93 4.24 4.24" /><path d="m14.83 9.17 4.24-4.24" /><path d="m14.83 14.83 4.24 4.24" /><path d="m9.17 14.83-4.24 4.24" /><circle cx="12" cy="12" r="4" /></Icon>
);

export const BarChart = (props) => (
    <Icon {...props}><title>Bar Chart</title><line x1="12" x2="12" y1="20" y2="10" /><line x1="18" x2="18" y1="20" y2="4" /><line x1="6" x2="6" y1="20" y2="16" /></Icon>
);

export const BarChartHorizontal = (props) => (
    <Icon {...props}><title>Bar Chart Horizontal</title><path d="M3 3v18h18" /><path d="M12 16V8" /><path d="M8 16v-5" /><path d="M16 16v-8" /></Icon>
);

export const AreaChart = (props) => (
    <Icon {...props}><title>Area Chart</title><path d="M3 3v18h18" /><path d="m3 21 9-9 4 4L21 3" /></Icon>
);

export const Search = (props) => (
    <Icon {...props}><title>Search</title><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></Icon>
);

export const Bell = (props) => (
    <Icon {...props}><title>Bell</title><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></Icon>
);

export const DollarSign = (props) => (
    <Icon {...props}><title>Dollar Sign</title><line x1="12" x2="12" y1="2" y2="22" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></Icon>
);

export const Rupee = (props) => (
    <Icon {...props}><title>Rupee</title><path d="M6 3h8a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2H8"/><path d="M6 8h12"/><path d="m12 8 4 8"/></Icon>
);

export const BarChart3 = (props) => (
    <Icon {...props}><title>Bar Chart 3</title><path d="M3 3v18h18" /><path d="M7 16V7" /><path d="M12 16v-4" /><path d="M17 16v-9" /></Icon>
);

export const PieChartIcon = (props) => (
    <Icon {...props}><title>Pie Chart</title><path d="M21.21 15.89A10 10 0 1 1 8 2.83" /><path d="M22 12A10 10 0 0 0 12 2v10z" /></Icon>
);

export const CheckCircle2 = (props) => (
    <Icon {...props}><title>Check Circle</title><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" /><path d="m9 12 2 2 4-4" /></Icon>
);

export const FileText = (props) => (
    <Icon {...props}><title>File Text</title><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></Icon>
);

export const ChevronDown = (props) => (
    <Icon {...props}><title>Chevron Down</title><path d="m6 9 6 6 6-6"/></Icon>
);

export const Clock = (props) => (
    <Icon {...props}><title>Clock</title><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></Icon>
);

export const TrendingUp = (props) => (
    <Icon {...props}><title>Trending Up</title><polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" /></Icon>
);

export const RefreshCw = (props) => (
    <Icon {...props}><title>Refresh</title><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" /><path d="M3 21v-5h5" /></Icon>
);

export const AlertTriangle = (props) => (
    <Icon {...props}><title>Alert Triangle</title><path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" /><path d="M12 9v4" /><path d="M12 17h.01" /></Icon>
);

export const MoreHorizontal = (props) => (
    <Icon {...props}><title>More Horizontal</title><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /><circle cx="5" cy="12" r="1" /></Icon>
);

export const CalendarDays = ({ title = "Calendar Days", ...props }) => (
    <Icon {...props}><title>{title}</title><rect width="18" height="18" x="3" y="4" rx="2" ry="2" /><line x1="16" x2="16" y1="2" y2="6" /><line x1="8" x2="8" y1="2" y2="6" /><line x1="3" x2="21" y1="10" y2="10" /></Icon>
);

export const ServerCrash = (props) => (
    <Icon {...props}><title>Server Crash</title><path d="M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2"/><path d="M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2"/><path d="M6 6h.01"/><path d="M6 18h.01"/><path d="m13 6-4 6h6l-4 6"/></Icon>
);

export const WifiOff = (props) => (
    <Icon {...props}><title>Wifi Off</title><line x1="2" x2="22" y1="2" y2="22"/><path d="M8.5 16.5a5 5 0 0 1 7 0"/><path d="M2 8.82a15 15 0 0 1 4.17-2.65"/><path d="M10.66 5c4.01-.36 8.14.9 11.34 3.76"/><path d="M16.85 11.25a10 10 0 0 1 2.22 1.68"/><path d="M5.15 11.25a10 10 0 0 0 2.22 1.68"/></Icon>
);

export const GripVertical = (props) => (
    <Icon {...props}><title>Grip Vertical</title><circle cx="9" cy="12" r="1" /><circle cx="9" cy="5" r="1" /><circle cx="9" cy="19" r="1" /><circle cx="15" cy="12" r="1" /><circle cx="15" cy="5" r="1" /><circle cx="15" cy="19" r="1" /></Icon>
);

export const TableIcon = (props) => (
    <Icon {...props}><title>Table View</title><path d="M12 3v18" /><rect width="18" height="18" x="3" y="3" rx="2" /><path d="M3 9h18" /><path d="M3 15h18" /></Icon>
);